import baseApi, { TAGS } from './baseApi';

/************************************************** API **************************************************/
const remindersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReminders: builder.query({
      query: (userId) => ({
        url: `reminders`,
        params: { userId },
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.USER_REMINDERS]
    }),
    upsertReminder: builder.mutation({
      query: (reminder) => ({
        url: 'reminders',
        method: 'PUT',
        body: reminder
      }),
      invalidatesTags: [TAGS.USER_REMINDERS]
    }),
    deleteReminder: builder.mutation({
      query: (id) => ({
        url: `reminders/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [TAGS.USER_REMINDERS]
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useGetRemindersQuery, useUpsertReminderMutation, useDeleteReminderMutation } = remindersApi;
